





















































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';
import profileApi from '@/api/profile.api';

@Component({
    computed: mapGetters({
        accountId: types.AUTH_GET_ACCOUNT_ID
    })
})
export default class ProfileAdmin extends EditPage {
    public parentPath: string = '/app/home';

    public formState: IDictionary<IFormControl> = {
        email: {
            key: 'email',
            label: 'Email',
            value: '',
            validators: 'required|email'
        },
        password: {
            key: 'password',
            label: 'Password',
            value: '',
            validators: 'confirmed:passwordConfirm'
        },
        passwordConfirm: {
            key: 'passwordConfirm',
            label: 'Confirm Password',
            value: '',
            validators: ''
        },
        showSuspend: {
            key: 'showSuspend',
            label: 'Show suspended',
            value: '',
            validators: ''
        }
    };

    public async created() {
        super.created();
        this.isNew = false;
        this.loading = true;
        try {
            const details = await profileApi.adminDetails();
            this.setValues(details);
        } finally {
            this.loading = false;
        }
    }

    protected create(id: number): Promise<any> {
        throw new Error('not supported');
    }

    protected detail(body: any): Promise<any> {
        throw new Error('not supported');
    }

    protected update(body: any): Promise<number> {
        return profileApi.updateAdmin(body);
    }
}
